import { css, cx } from "@emotion/css";
import { mergeProps } from "react-aria";
import {
  Table as AriaTable,
  TableProps as AriaTableProps,
} from "react-aria-components";

import { getTextStyle } from "../../../foundations/typography/styles";

export interface TableProps extends AriaTableProps {
  stickyHeader?: boolean;
  fixedLayout?: boolean;
  hasStretchedRowLink?: boolean;
}

export function Table(props: TableProps) {
  const { hasStretchedRowLink, ...tableProps } = props;
  const { selectionBehavior } = tableProps;

  return (
    <AriaTable
      {...mergeProps(tableProps, {
        className: cx(
          styles.table,
          props.stickyHeader && styles.stickyHeader,
          (props.onRowAction ||
            selectionBehavior === "toggle" ||
            hasStretchedRowLink) &&
            styles.selectableRows,
          props.fixedLayout && css({ tableLayout: "fixed" })
        ),
      })}
    />
  );
}

const styles = {
  table: css(
    {
      outline: "none",
      "&[data-focus-visible]": { boxShadow: "var(--focus-action)" },
      width: "100%",
      boxSizing: "border-box",
      "th,td": { boxSizing: "border-box" },
      borderCollapse: "collapse",
      "tbody tr": {
        borderBottomWidth: 1,
        borderBottomStyle: "solid",
      },
      "thead tr": {
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
      },
      "tr, th": { borderColor: "var(--border-base)" },
    },

    getTextStyle("form/body-secondary")
  ),
  stickyHeader: css({
    th: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: "var(--background-base)",
    },
  }),
  selectableRows: css({
    "tbody tr": {
      cursor: "pointer",

      "&[data-hovered]": {
        backgroundColor: "var(--background-ghost-hover)",
      },
      "&:has(button[data-hovered]), &:has(button[data-pressed])": {
        backgroundColor: "transparent",
      },
    },
  }),
};
